import {IWindowService} from "angular";

/* @ngInject */
export const encodeUriComponentFilterFactory = ($window: IWindowService) => $window.encodeURIComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/filter/encodeUriComponent.filter.ts